export default __webpack_public_path__ + "static/media/whatsapp-campaign-3.ea89c47f.png";